class ReadMore extends window.BAO.CustomElement() {
  constructor () {
    super();

    this.handleReadMoreClick = this.handleReadMoreClick.bind(this);

    this.els.readMore.elements.forEach((el) => {
      el.addEventListener("click", this.handleReadMoreClick);
    })

    this.handleReadLessClick = this.handleReadLessClick.bind(this);

    this.els.readLess.elements.forEach((el) => {
      el.addEventListener("click", this.handleReadLessClick);
    })
  }

  handleReadMoreClick (event) {
    const shortDescriptionEl = this.els.short.element;
    const fullDescriptionEl = this.els.full.element;

    shortDescriptionEl.setAttribute('aria-hidden', 'true');
    fullDescriptionEl.setAttribute('aria-hidden', 'false');
  }

  handleReadLessClick (event) {
    const shortDescriptionEl = this.els.short.element;
    const fullDescriptionEl = this.els.full.element;

    shortDescriptionEl.setAttribute('aria-hidden', 'false');
    fullDescriptionEl.setAttribute('aria-hidden', 'true');
  }

  connectedCallback () {
    super.connectedCallback();
  }
}

if (!customElements.get('read-more')) {
  customElements.define('read-more', ReadMore);
}